import { Component } from '@angular/core';
import { SecurityLoginModel } from 'src/app/model/security/security-login';
import { BaseComponent } from '../core/base/base.component';
import { LOGIN_CONSTANTS } from './login.constants';
import { LoginService } from './login.service';

@Component({
  selector: 'ms-login.login__wrapper',
  templateUrl: './login.component.html',
  styleUrls: ['./login.styles.scss'],
})
export class LoginViewComponent extends BaseComponent {
  override screen = LOGIN_CONSTANTS;
  override setScreen = true;
  data: SecurityLoginModel = {};

  constructor(override service: LoginService) {
    super();
  }

  override onInit = () => {
    this.service.init();
  };

  login = () => {
    this.service.setLoadingState();
    this.service.login(this.data).subscribe();
  };
}
